import { parseMoney } from './';

import type { FormatMoneyFunction, LocalizeMoneyFunction } from './types';

/**
 * Curried function that formats the given amount by the number of decimal places
 */
export const formatMoney: FormatMoneyFunction = (decimalPlaces) => (amount) => {
	const newParsedAmount = parseMoney(amount);
	// newParsedAmount may be NaN
	return isNaN(newParsedAmount) ? '' : newParsedAmount.toFixed(decimalPlaces);
};

/**
 * Curried function that formats the given amount by the number of decimal places AND the supplied locale
 */
export const localizeMoney: LocalizeMoneyFunction =
	({ locale, decimalPlaces, decimalMark, thousandsSeparator }) =>
	(amount) => {
		return new Intl.NumberFormat(locale, {
			maximumFractionDigits: 6,
			minimumFractionDigits: decimalPlaces,
			useGrouping: true, // necessary to replace decimal mark and thousands separator
		})
			.formatToParts(parseMoney(amount))
			.map(({ value, type }) => {
				switch (type) {
					case 'group': // thousands separator
						return thousandsSeparator;
					case 'decimal': // decimal mark
						return decimalMark;
					default:
						return value; // return as-is
				}
			})
			.join('');
	};
